import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const MentionsLegalesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6 text-muted-foreground hover:text-foreground"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: '#1E40AF' }}>
          Mentions Légales
        </h1>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">1. Éditeur du site</h2>
            <p className="mb-3">Le site https://devisfast.fr et l'application DevisFast sont édités par :</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Raison sociale : ZANATTA CONSULTING</li>
              <li>Forme juridique : SARL (Société à Responsabilité Limitée)</li>
              <li>Capital social : 1 666 000,00 €</li>
              <li>Siège social : 9 Clos de Poumarol, 31320 Aureville</li>
              <li>SIRET : 850 771 452 00024</li>
              <li>RCS : 850 771 452 R.C.S. Toulouse</li>
              <li>N° TVA intracommunautaire : FR25850771452</li>
              <li>Gérant : Stéphane ZANATTA</li>
              <li>Email : support@devisfast.fr</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">2. Hébergement</h2>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>Render Services, Inc. — 525 Brannan Street, Suite 300, San Francisco, CA 94107, États-Unis — https://render.com (hébergement application)</li>
              <li>MongoDB, Inc. — 1633 Broadway, 38th Floor, New York, NY 10019, États-Unis — https://www.mongodb.com (base de données)</li>
              <li>OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — https://www.ovhcloud.com (messagerie professionnelle)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">3. Propriété intellectuelle</h2>
            <p>L'ensemble du contenu de DevisFast (textes, graphismes, logiciels, images, etc.) est protégé par le droit de la propriété intellectuelle et appartient exclusivement à ZANATTA CONSULTING ou fait l'objet d'une autorisation d'utilisation. Toute reproduction, distribution, modification ou utilisation sans autorisation préalable écrite est strictement interdite.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">4. Responsabilité</h2>
            <p>ZANATTA CONSULTING s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur DevisFast. Toutefois, ZANATTA CONSULTING ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition et décline toute responsabilité pour toute imprécision, inexactitude ou omission.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">5. Données personnelles</h2>
            <p>Les données personnelles collectées via DevisFast sont traitées conformément à notre Politique de Confidentialité accessible sur https://devisfast.fr/privacy. Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour exercer ces droits : support@devisfast.fr</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">6. Cookies</h2>
            <p>DevisFast utilise des cookies techniques nécessaires au fonctionnement du service. Ces cookies ne collectent pas de données personnelles à des fins publicitaires.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">7. Droit applicable</h2>
            <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-3">8. Contact</h2>
            <p>Pour toute question : support@devisfast.fr</p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-center text-sm text-muted-foreground">
          Dernière mise à jour : 09/03/2026
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
